module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('defs', [_c('pin-spot'), _vm._v(" "), _c('pin-spot-full'), _vm._v(" "), _c('pin-spot-restroom-male'), _vm._v(" "), _c('pin-spot-restroom-female'), _vm._v(" "), _c('pin-spot-restroom-shared'), _vm._v(" "), _c('pin-spot-dome'), _vm._v(" "), _c('pin-person'), _vm._v(" "), _c('visualization-setstar'), _vm._v(" "), _c('visualization-sound'), _vm._v(" "), _c('visualization-eco2'), _vm._v(" "), _c('visualization-wind-speed')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce8b3ec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/decoration/defs.vue
// module id = 861
// module chunks = 0